// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-c3c3a672] .v-expansion-panel-content__wrap {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
